import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ProjectDocumentApi, ProjectDocumentApiImpl } from './src/infrastructure/api/project-document-api';

export * from './src/infrastructure/api/project-document-api';

export const selectLlmModule = new ContainerModule((bind) => {
    bind(ProjectDocumentApi).to(ProjectDocumentApiImpl);
});
